export const red = {
  100: 'var(--bfc-v2-color-red-100, #ffeceb)',
  200: 'var(--bfc-v2-color-red-200, #ffd5d2)',
  300: 'var(--bfc-v2-color-red-300, #fd9891)',
  400: 'var(--bfc-v2-color-red-400, #f87168)',
  500: 'var(--bfc-v2-color-red-500, #f15b50)',
  600: 'var(--bfc-v2-color-red-600, #e2483d)',
  700: 'var(--bfc-v2-color-red-700, #c9372c)',
  800: 'var(--bfc-v2-color-red-800, #ae2e24)',
  900: 'var(--bfc-v2-color-red-900, #5d1f1a)',
  1000: 'var(--bfc-v2-color-red-1000, #42221f)',
  DEFAULT: 'var(--bfc-v2-color-red-700, #c9372c)', // 700
};
